import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import type { StatusBreakdown as StatusBreakdownRow } from '@/types';
import { StatusBreakdownChart } from './StatusBreakdownChart';

export function StatusBreakdown({ data }: { data: StatusBreakdownRow[] }) {
  if (data.length === 0) {
    return null;
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Submission Status Breakdown</CardTitle>
        <CardDescription>
          Distribution of submissions by status and modality. Team bars show
          both submission count and total hacker count.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <StatusBreakdownChart data={data} />
      </CardContent>
    </Card>
  );
}
